import script from "./UiMenu.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiMenu.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiMenu.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./UiMenu.vue.scss?vue&type=style&index=0&id=838d880a&lang=scss&module=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./UiMenu.vue?vue&type=style&index=0&id=838d880a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__